import { useState, useEffect } from 'react';
import { graphql, commitMutation, useRelayEnvironment } from 'react-relay';
import { useTranslation } from '@/helpers/translate';

const validemailMutation = graphql`
  mutation userMessageMutation {
    corpoSendValidEmail {
      code
      success
      message
    }
  }
`;

const onClickSendValidEmail = (environment, callback) => {
  commitMutation(
    environment,
    {
      mutation: validemailMutation,
      variables: {},
      onCompleted: (res) => {
        if (!res || res?.corpoSendValidEmail?.code !== 200) return callback({ message: res?.corpoSendValidEmail?.message || 'corpo:error.fromdgs' });
        return callback(null, true);
      },
      onError: (err) => {
        console.error(err);
        return callback({ message: err?.message || 'corpo:error.onError' });
      },
    },
  );
};

function RequireValidEmail() {
  const environment = useRelayEnvironment();
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState('');
  const { t } = useTranslation();
  const click = () => {
    setError(false);
    setSuccess('');
    onClickSendValidEmail(environment, (err) => {
      if (err) return setError(err?.message);
      return setSuccess(t('corpo:success.validmailsended'));
    });
  };
  return (
    <div className="flex flex-col items-center justify-between px-3 py-2 mb-2 lg:rounded-b-lg bg-purple/60 lg:px-4 lg:flex-row lg:gap-4">
      <div className="flex flex-col items-center lg:flex-row lg:gap-3">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6 text-white/70">
          <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 9v.906a2.25 2.25 0 0 1-1.183 1.981l-6.478 3.488M2.25 9v.906a2.25 2.25 0 0 0 1.183 1.981l6.478 3.488m8.839 2.51-4.66-2.51m0 0-1.023-.55a2.25 2.25 0 0 0-2.134 0l-1.022.55m0 0-4.661 2.51m16.5 1.615a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V8.844a2.25 2.25 0 0 1 1.183-1.981l7.5-4.039a2.25 2.25 0 0 1 2.134 0l7.5 4.039a2.25 2.25 0 0 1 1.183 1.98V19.5Z" />
        </svg>
        <span className="text-sm text-center text-white lg:text-base lg:text-left">{t('corpo:email.need_valid')}</span>
      </div>
      {success ? (
        <p className="px-2 py-1 text-sm border rounded-lg text-white/80 bg-white/10 border-white/10 lg:px-3 lg:py-1">{success}</p>
      ) : (
        <div className="flex flex-col items-center lg:flex-row lg:gap-4">
          <button className="px-2 py-1 text-sm text-white border border-white/50 lg:px-3 lg:py-1" onClick={() => click()}>{t('corpo:btn.resend')}</button>
          {error && (
            <p className="text-red">Erreur - {error}</p>
          )}
        </div>
      )}
    </div>
  );
}

function UserMessage({
  loginRequired,
  validEmail,
  needApproval,
  notAdmin,
  somethingWrong,
  requireValidEmail,
  notAllow,
}) {
  const { t } = useTranslation();
  const [render, setRender] = useState(false);

  useEffect(() => {
    setRender(true);
  }, []);

  if (!render) return null;

  if (notAllow) {
  return <>
    <div className="flex items-center justify-center py-28">
      <div className="p-8 text-center bg-white max-w-fit lg:max-w-2/7 rounded-xl">
        <div className="flex flex-col items-center gap-3">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 text-black">
            <path strokeLinecap="round" strokeLinejoin="round" d="M18.364 18.364A9 9 0 0 0 5.636 5.636m12.728 12.728A9 9 0 0 1 5.636 5.636m12.728 12.728L5.636 5.636" />
          </svg>
          <span className="text-dark-deep">{t('corpo:error.not_allow')}</span>
        </div>
      </div>
    </div>
         </>;
  }
  if (notAdmin) {
 return <>
    <div className="flex items-center justify-center py-28">
      <div className="p-8 text-center bg-white max-w-fit lg:max-w-2/7 rounded-xl">
        <div className="flex flex-col items-center gap-3">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 text-black">
            <path strokeLinecap="round" strokeLinejoin="round" d="M18.364 18.364A9 9 0 0 0 5.636 5.636m12.728 12.728A9 9 0 0 1 5.636 5.636m12.728 12.728L5.636 5.636" />
          </svg>
          <span className="text-dark-deep">{t('corpo:error.need_valid_email')}</span>
        </div>
      </div>
    </div>
        </>;
  }
  if (validEmail) {
 return <>
    <div className="flex items-center justify-center py-28">
      <div className="p-8 text-center bg-white max-w-fit lg:max-w-2/7 rounded-xl">
        <div className="flex flex-col items-center gap-3">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-8 h-8 text-black">
            <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 9v.906a2.25 2.25 0 0 1-1.183 1.981l-6.478 3.488M2.25 9v.906a2.25 2.25 0 0 0 1.183 1.981l6.478 3.488m8.839 2.51-4.66-2.51m0 0-1.023-.55a2.25 2.25 0 0 0-2.134 0l-1.022.55m0 0-4.661 2.51m16.5 1.615a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V8.844a2.25 2.25 0 0 1 1.183-1.981l7.5-4.039a2.25 2.25 0 0 1 2.134 0l7.5 4.039a2.25 2.25 0 0 1 1.183 1.98V19.5Z" />
          </svg>
          <span className="text-dark-deep">{t('corpo:error.need_valid_email')}</span>
        </div>
      </div>
    </div>
        </>;
}
if (needApproval) {
 return <>
    <div className="flex items-center justify-center py-28">
      <div className="p-8 text-center bg-white max-w-fit lg:max-w-2/7 rounded-xl">
        <div className="flex flex-col items-center gap-3">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 text-black">
            <path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />
          </svg>
          <span className="text-dark-deep">{t('corpo:error.need_approval')}</span>
        </div>
      </div>
    </div>
        </>;
}
if (loginRequired) {
 return <>
    <div className="flex items-center justify-center py-28">
      <div className="p-8 text-center bg-white max-w-fit lg:max-w-2/7 rounded-xl">
        <div className="flex flex-col items-center gap-3">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 text-black">
            <path strokeLinecap="round" strokeLinejoin="round" d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
          </svg>
          <span className="text-dark-deep">{t('corpo:error.need_login')}</span>
        </div>
      </div>
    </div>
        </>;
}
if (somethingWrong === 'validemailadminapprove') {
  return <>
     <div className="flex items-center justify-center py-28">
       <div className="p-8 text-center bg-white max-w-fit lg:max-w-2/7 rounded-xl">
         <div className="flex flex-col items-center gap-3">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 text-black">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
            </svg>
           <span className="text-dark-deep">{t('corpo:error.validemailadminapprove')}</span>
         </div>
       </div>
     </div>
         </>;
 }
 if (somethingWrong === 'waitinginvitebyadmin') {
  return <>
     <div className="flex items-center justify-center py-28">
       <div className="p-8 text-center bg-white max-w-fit lg:max-w-2/7 rounded-xl">
         <div className="flex flex-col items-center gap-3">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 text-black">
            <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
          </svg>
           <span className="text-dark-deep">{t('corpo:error.waitinginvitebyadmin')}</span>
         </div>
       </div>
     </div>
         </>;
 }
  if (somethingWrong) {
    return (
      <div>
        Erreur !
        {somethingWrong}
      </div>
    );
  }
  if (requireValidEmail) return <RequireValidEmail />;
  return null;
}

export default UserMessage;
